import Select from '@components/Select';
import type { VideoQuality } from '@hooks/sdk/useSelectVideoQuality';
import useSelectVideoQuality from '@hooks/sdk/useSelectVideoQuality';
import type { BaseComponentProps } from '@interfaces/selection';
import type { ChangeEvent, FC, PropsWithChildren } from 'react';
import { getQualityOptions } from './config';
import { Container } from './style';

interface QualitySelectionProps extends BaseComponentProps {}

const QualitySelection: FC<PropsWithChildren<QualitySelectionProps>> = (
  props,
) => {
  const selectVideoQuality = useSelectVideoQuality();

  async function selectQuality(e: ChangeEvent<HTMLSelectElement>) {
    const quality = e.target.value as VideoQuality;
    selectVideoQuality(quality);
  }

  return (
    <Container>
      <Select {...props} onChange={selectQuality}>
        {getQualityOptions.map(({ value, label }) => (
          <option value={value} key={value}>
            {label}
          </option>
        ))}
      </Select>
    </Container>
  );
};

export default QualitySelection;
